import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M22.42,11.4l-10-7A.75.75,0,0,0,11.24,5v5.55L2.43,4.42a.76.76,0,0,0-.78,0,.74.74,0,0,0-.4.66V19a.76.76,0,0,0,.75.75.76.76,0,0,0,.43-.14l8.81-6.13V19a.75.75,0,0,0,.4.66.73.73,0,0,0,.35.09.76.76,0,0,0,.43-.14l10-6.95a.75.75,0,0,0,0-1.23ZM2.75,17.53V6.47L10.68,12Zm10,0V6.47L20.68,12Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowForwardIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'arrowForward'),
) as IconWithRender;

ArrowForwardIcon.displayName = 'ArrowForwardIcon';
ArrowForwardIcon.propTypes = Icon.propTypes;
ArrowForwardIcon.renderIcon = (props) => <ArrowForwardIcon {...props} />;
export default ArrowForwardIcon;
